import PropTypes from "prop-types";

export const OverrideDetail = ({ label, from, to }) => (
  <li className="body-2">
    {label} from <strong>{from}</strong> to <strong>{to}</strong>
  </li>
);

OverrideDetail.propTypes = {
  label: PropTypes.string.isRequired,
  from: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};
